import { z } from "zod";

export const recruitmentSchema = z.object({
  title: z
    .string({ required_error: "Le titre est obligatoire" })
    .min(3, { message: "Le titre doit comporter au moins 3 caractères." }),

  description: z.string({ required_error: "La description est obligatoire" }),
});

export type RecruitmentFormValues = z.infer<typeof recruitmentSchema>;

export const updateRecruitmentSchema = z
  .object({
    title: z
      .string()
      .min(3, { message: "Le titre doit comporter au moins 3 caractères." }),

    description: z.string({ required_error: "Description est obligatoire" }),
  })
  .partial();

export type UpdateRecruitmentFormValues = z.infer<
  typeof updateRecruitmentSchema
>;
